













import Component from "vue-class-component";
import Vue from "vue";
import { VPagination } from "vuetify/lib";
import { castComponent } from "@/lib/helpers";
import { Prop } from "vue-property-decorator";

Vue.component("VPagination", castComponent(VPagination));
@Component({ name: "BasePagination" })
export default class BasePagination extends Vue {
  @Prop({ type: Number, required: true })
  public readonly length!: number;

  @Prop({ type: Number, default: 9 })
  public readonly totalVisible!: number;

  @Prop({ type: Number, default: 5 })
  public readonly totalVisibleXs!: number;

  @Prop({ type: Number, required: true })
  public readonly value!: number;
}
